;(function ($) {
  const semesterCategoryGrid = $('.semester__category__content')
  semesterCategoryGrid.isotope({
    // options
    itemSelector: '.grid__item',
    masonry: {
      columnWidth: '.grid__sizer',
      gutter: '.grid__gutter',
    },
  })
  semesterCategoryGrid.imagesLoaded().done(function () {
    semesterCategoryGrid.isotope('layout')
  })

  $(document).on('click', '.semester__category__load-more__btn', function (e) {
    e.preventDefault()
    $button = $(this)
    const data = {
      url: $button.data('url'),
      action: 'curriculum_load_more',
      page: parseInt($button.attr('page')),
      parent: $button.data('parent'),
      category: $button.data('category'),
      year: $button.data('year'),
    }

    $.ajax({
      url: data.url,
      type: 'POST',
      data,
      error: (res) => {
        console.log(res)
      },
      success: (res) => {
        let $content = $(res.data)
        $('#' + data.category)
          .append($content)
          .isotope('appended', $content)

        data.page += 1
        $button.attr('page', data.page)

        if (data.page >= res.max_num_pages) {
          $button.closest('.semester__category__load-more').hide()
        }
      },
    })
  })
})(jQuery)
